import React, { useEffect } from 'react';
import { compose } from 'redux';
import { Box, ModalProps } from '@material-ui/core';
import { FieldArray, reduxForm, getFormValues } from 'redux-form/immutable';
import { useSelector, useDispatch } from 'react-redux';

import countries from 'utils/countries';
import partnerModalHeader from 'assets/partner-modal-header.avif';
import Img from 'retired/Img';
import FormNonprofitsSelectorRedesign from 'retired/FormNonprofitsSelectorRedesign';
import { Modal, ModalContents, ModalTitle, ModalButton } from 'components/Modal/Modal';
import { selectPartners } from 'entities/partners/selectors';

import {
  ADD_PARTNER_NONPROFIT_FORM_IDENTIFIER,
  clearErrorAction,
  createPartnerAction,
} from './types';

const AddPartnerNonprofitModal = ({
  onClickClose,
  style,
  ...props
}: {
  onClickClose: () => void;
} & ModalProps): JSX.Element => {
  const dispatch = useDispatch();
  const formValues = useSelector(getFormValues(ADD_PARTNER_NONPROFIT_FORM_IDENTIFIER));
  const partners = useSelector(selectPartners);

  useEffect(() => {
    dispatch(clearErrorAction());
  }, []);

  const nonprofitId = formValues?.getIn(['nonprofits', 0, 'id']);

  return (
    <Modal
      disableAutoFocus
      style={{
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
      {...props}
    >
      <ModalContents
        onClickClose={onClickClose}
        header={
          <Img
            src={partnerModalHeader}
            alt=""
            style={{
              width: 600,
              height: 145,
            }}
          />
        }
        body={
          <>
            <ModalTitle>Add an affiliation</ModalTitle>
            <Box paddingTop={4}>
              <form>
                <FieldArray
                  name="nonprofits"
                  component={FormNonprofitsSelectorRedesign}
                  fullWidth
                  autoFocus
                  required
                  limit={1}
                  initialLocation={countries.US.alpha2}
                  variant="standard"
                  locationSelectorLabel="Organization country"
                  locationSelectorPlaceholder="Enter their operating country"
                  nonprofitSelectorLabel="Organization name"
                  nonprofitSelectorPlaceholder="Search by their name or Employer Identification Number (EIN)"
                  filterOptions={(options) =>
                    options.filter((option) =>
                      partners.every((partner) => partner.id !== option._id)
                    )
                  }
                />
              </form>
            </Box>
          </>
        }
        actions={
          <>
            <ModalButton
              disabled={!nonprofitId}
              onClick={(): void => {
                dispatch(createPartnerAction(nonprofitId));
                onClickClose();
              }}
            >
              Add affiliation +
            </ModalButton>
          </>
        }
      />
    </Modal>
  );
};

const withForm = reduxForm({
  form: ADD_PARTNER_NONPROFIT_FORM_IDENTIFIER,
  enableReinitialize: true,
});

export default compose(withForm)(AddPartnerNonprofitModal);
